<template>
  <div>
    <div
      class="modal fade"
      id="modalCheckin"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalCheckinTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalCheckinTitle">Check-List do Veículo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5">
                <img class="car-pic" :src="dataModal.vehicles.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">{{ dataModal.vehicles.description }}</div>
                    <div class="data">{{ dataModal.vehicles.board }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Reservado Para:</div>
                    <div class="data">
                      {{
                      dataModal.user.name
                      }}
                      <button
                        class="btn btn-user"
                        data-tooltip="tooltip"
                        title="Dados do Usuário"
                        data-dismiss="modal"
                        data-toggle="modal"
                        @click="openModalUser(dataModal)"
                      >
                        <i class="fas fa-user"></i>
                      </button>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirada Estimada:</div>
                    <div class="data">
                      {{
                      dataModal.retreat_date
                      }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirado em:</div>
                    <div class="data">
                      {{
                      dataModal.checkout
                      ? dataModal.checkout.retreat_at
                      : ""
                      }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Devolução Estimada:</div>
                    <div class="data">
                      {{
                      dataModal.devolution_date
                      }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc" v-if="dataModal.reserve_status.id == '5'">
                    <div class="text">Devolvido em:</div>
                    <div class="data">{{ dataModal.checkin ? dataModal.checkin.devoluted_at : "" }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                      <div class="data km-total">
                        <the-mask
                        disabled
                        class="km-in-modal"
                        :value="dataModal.vehicles.current_km"
                        :mask="['####', '#.###', '##.###', '###.###']"
                        />
                      </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <ul class="nav nav-pills nav-justified" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pills-checkout02-tab"
                  data-toggle="pill"
                  href="#pills-checkout02"
                  role="tab"
                  aria-controls="pills-checkout02"
                  aria-selected="false"
                >Check-Out</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-checkin02-tab"
                  data-toggle="pill"
                  href="#pills-checkin02"
                  role="tab"
                  aria-controls="pills-checkin02"
                  aria-selected="true"
                >Check-In</a>
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-checkout02"
                role="tabpanel"
                aria-labelledby="pills-checkout02-tab"
              >
                <div class="row mt-3">
                  <div class="col-md-7">
                    <div class="check-part">Km no momento do check-out</div>
                    <div class="new-km mb-3">
                      <span>{{ dataModal.checkout.km_checkout }}</span>
                      km
                    </div>
                    <div class="check-part">Combustível</div>
                    <div class="row pl-3 pr-3 mb-3">
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkout.combustible == '0' ? 'check' : '' ]"
                      >0</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkout.combustible == '1/4' ? 'check' : '' ]"
                      >1/4</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkout.combustible == '1/2' ? 'check' : '' ]"
                      >1/2</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkout.combustible == '3/4' ? 'check' : '' ]"
                      >3/4</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkout.combustible == '7/8' ? 'check' : '' ]"
                      >7/8</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkout.combustible == 'Cheio' ? 'check' : '' ]"
                      >Cheio</div>
                    </div>
                    <div class="check-part">Avarias</div>
                    <div class="car-damage mb-3">
                      <div class="dmg-position">
                        Frontal
                        <span
                          v-if="
                              dataModal
                                .checkout &&
                                dataModal
                                  .checkout.bkd_frontal
                            "
                        >
                          {{
                          dataModal
                          .checkout.bkd_frontal.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Lateral Direita
                        <span
                          v-if="
                              dataModal
                                .checkout &&
                                dataModal
                                  .checkout.bkd_right_side
                            "
                        >
                          {{
                          dataModal
                          .checkout.bkd_right_side.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Traseira
                        <span
                          v-if="
                              dataModal
                                .checkout &&
                                dataModal
                                  .checkout.bkd_rear
                            "
                        >
                          {{
                          dataModal.checkout.bkd_rear.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Lateral Esquerda
                        <span
                          v-if="
                              dataModal
                                .checkout &&
                                dataModal.checkout.bkd_left_side
                            "
                        >
                          {{
                          dataModal
                          .checkout.bkd_left_side.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Teto
                        <span
                          v-if="
                              dataModal
                                .checkout &&
                                dataModal.checkout.bkd_ceiling
                            "
                        >
                          {{
                          dataModal
                          .checkout.bkd_ceiling.description
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="check-part">Adicionais</div>
                    <div class="car-adds mb-3">
                      <div class="car-add" v-for="ci1 in checklist_items" :key="ci1.id">
                        <div class="add-type">{{ ci1.description }}</div>
                        <div class="custom-control custom-switch">
                          <div v-for="vi1 in dataModal.checkout.checklist_itens" :key="vi1.id">
                            <div v-show="vi1.id == ci1.id">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="ci1.id + 'b'"
                                :checked="vi1.id == ci1.id"
                                disabled
                              />
                              <label class="custom-control-label" :for="ci1.id + 'b'"></label>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="damages-check">
                      <img src="../../assets/images/damages.png" alt />
                      <div
                        :class="[
                            dataModal.checkout
                              .bkd_frontal.id > 1
                              ? 'damage-pin pin-04'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkout
                              .bkd_right_side.id > 1
                              ? 'damage-pin pin-03'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkout
                              .bkd_left_side.id > 1
                              ? 'damage-pin pin-01'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkout
                              .bkd_rear.id > 1
                              ? 'damage-pin pin-02'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkout
                              .bkd_ceiling.id > 1
                              ? 'damage-pin pin-05'
                              : ''
                          ]"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="check-part">Outras Anotações</div>
                    <div class="check-text">{{dataModal.checkout.notes}}</div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="check-part">Fotos</div>
                    <div style="text-align: center;">
                      <a @click="openLightbox(dataModal.checkout)" class="btn btn-photo max">
                        Visualizar fotos do Check-Out
                        <i class="fas fa-camera"></i>
                        <br />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="pills-checkin02"
                role="tabpanel"
                aria-labelledby="pills-checkin02-tab"
              >
                <div class="row mt-3" v-if="dataModal.reserve_status.id == 5">
                  <div class="col-md-7">
                    <div class="check-part">Km Atual</div>
                    <div class="new-km mb-3">
                      <span>{{dataModal.checkin.atual_km}}</span> km
                    </div>
                    <div class="check-part">Combustível</div>
                    <div class="row pl-3 pr-3 mb-3">
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkin.combustible == '0' ? 'check' : '' ]"
                      >0</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkin.combustible == '1/4' ? 'check' : '' ]"
                      >1/4</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkin.combustible == '1/2' ? 'check' : '' ]"
                      >1/2</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkin.combustible == '3/4' ? 'check' : '' ]"
                      >3/4</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkin.combustible == '7/8' ? 'check' : '' ]"
                      >7/8</div>
                      <div
                        class="col-2 gas"
                        :class="[ dataModal.checkin.combustible == 'Cheio' ? 'check' : '' ]"
                      >Cheio</div>
                    </div>
                    <div class="check-part">Avarias</div>
                    <div class="car-damage mb-3">
                      <div class="dmg-position">
                        Frontal
                        <span
                          v-if="
                              dataModal
                                .checkin &&
                                dataModal
                                  .checkin.bkd_frontal
                            "
                        >
                          {{
                          dataModal
                          .checkin.bkd_frontal.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Lateral Direita
                        <span
                          v-if="
                              dataModal
                                .checkin &&
                                dataModal
                                  .checkin.bkd_right_side
                            "
                        >
                          {{
                          dataModal
                          .checkin.bkd_right_side.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Traseira
                        <span
                          v-if="
                              dataModal
                                .checkin &&
                                dataModal
                                  .checkin.bkd_rear
                            "
                        >
                          {{
                          dataModal.checkin.bkd_rear.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Lateral Esquerda
                        <span
                          v-if="
                              dataModal
                                .checkin &&
                                dataModal.checkin.bkd_left_side
                            "
                        >
                          {{
                          dataModal
                          .checkin.bkd_left_side.description
                          }}
                        </span>
                      </div>
                      <div class="dmg-position">
                        Teto
                        <span
                          v-if="
                              dataModal
                                .checkin &&
                                dataModal.checkin.bkd_ceiling
                            "
                        >
                          {{
                          dataModal
                          .checkin.bkd_ceiling.description
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="check-part">Adicionais</div>
                    <div class="car-adds mb-3">
                      <div class="car-add" v-for="ci2 in checklist_items" :key="ci2.id">
                        <div class="add-type">{{ ci2.description }}</div>
                        <div class="custom-control custom-switch">
                          <div v-for="vi2 in dataModal.checkin.checklist_itens" :key="vi2.id">
                            <div v-show="vi2.id == ci2.id">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="ci2.id + 'b'"
                                :checked="vi2.id == ci2.id"
                                disabled
                              />
                              <label class="custom-control-label" :for="ci2.id + 'b'"></label>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="damages-check">
                      <img src="../../assets/images/damages.png" alt />
                      <div
                        :class="[
                            dataModal.checkin
                              .bkd_frontal.id > 1
                              ? 'damage-pin pin-04'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkin
                              .bkd_right_side.id > 1
                              ? 'damage-pin pin-03'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkin
                              .bkd_left_side.id > 1
                              ? 'damage-pin pin-01'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkin
                              .bkd_rear.id > 1
                              ? 'damage-pin pin-02'
                              : ''
                          ]"
                      ></div>
                      <div
                        :class="[
                            dataModal.checkin
                              .bkd_ceiling.id > 1
                              ? 'damage-pin pin-05'
                              : ''
                          ]"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3" v-if="dataModal.reserve_status.id == 5">
                  <div class="col-md-12">
                    <div class="check-part">Outras Anotações</div>
                    <div class="check-text">{{dataModal.checkin.notes}}</div>
                  </div>
                </div>
                <div class="row mt-3" v-if="dataModal.reserve_status.id == 5">
                  <div class="col-md-12">
                    <div class="check-part">Fotos</div>
                    <div style="text-align: center;">
                      <a @click="openLightbox(dataModal.checkin)" class="btn btn-photo max">
                        Visualizar fotos do Check-In
                        <i class="fas fa-camera"></i>
                        <br />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row mt-3" v-else>
                  <div class="col-md-12">
                    <div class="no-check">Check-In não realizado.</div>
                    <div class="no-check-data">
                      Devolução estimada para
                      <span>{{dataModal.devolution_date}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: ["modalStatus", "dataModal"],

  data() {
    return {
      checklist_items: []
    };
  },
  watch: {
    modalStatus: function(newStatus) {
      console.log(this.dataModal);
      if (newStatus == true) {
        this.startModal();
      }
    }
  },
  computed: {},
  mounted() {
    if (this.modalStatus == true) {
      this.startModal();
      this.getChecklistItens();
    }
  },
  methods: {
    openLightbox(object) {
      this.$emit("OpenLightbox", object);
    },
    openModalUser(object) {
      this.$emit("OpenModalUser", object);
    },
    startModal() {
      this.clean();
      $("#modalCheckin").modal("toggle");
    },
    clean() {
      this.$emit("changeModal", false);
    },
    getChecklistItens: function() {
      const self = this;
      const api = self.$store.state.api + "checklistItems/";

      self.$http.get(api).then(response => {
        self.checklist_items = response.data.data;
        self.ciCount = response.data.count;

        // for (let i = 0; i < self.ciCount; i++) {
        //   if (
        //     self.checklist_items[i].id == 1 ||
        //     self.checklist_items[i].id == 3
        //   ) {
        //     self.checked[i] = true;
        //   } else {
        //     self.checked[i] = false;
        //   }
        // }
      });
    }
  }
};
</script>

<style scoped>
.max {
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/CheckinModal.vue